import {
  ActivityLogDetailValue,
  ConditionDetailData,
  FullObject as FullObjectModel,
  NormaliseCheck as NormaliseCheckModel,
} from '@/api';
import { FCT } from '@/i18n';

import { ActionClass, IGNORED_FIELDS } from '../activity-log.constant';
import { generateTitle } from '../activity-log.util';
import { ActivityLogDetail } from './activity-log-detail.component';
import { ConditionDetail } from './condition-detail.component';
import { NormaliseCheck } from './normalise-check.component';

interface FullObjectProps {
  action: ActionClass;
  fullObject: FullObjectModel | null;
}

export function FullObject({ action, fullObject }: FullObjectProps) {
  return (
    <div className="pt-2">
      {fullObject &&
        Object.entries(fullObject).map(([key, value]) => {
          if (key === 'conditionDetail' && Array.isArray(value)) {
            return fullObject[key]?.map((conditionDetail: ConditionDetailData) => (
              <ConditionDetail
                key={conditionDetail.name}
                action={action}
                conditionDetail={conditionDetail}
                fieldName={conditionDetail.name}
                fullObject={fullObject}
              />
            ));
          }

          if (key === 'normaliseCheck') {
            return (
              <NormaliseCheck
                key={key}
                action={action}
                item={key}
                normaliseObject={fullObject[key] as NormaliseCheckModel}
              />
            );
          }

          if (key === 'descriptionOfCall' || key === 'reasonForAccessingPtInfo') {
            return (
              <ActivityLogDetail
                key={key}
                action={action}
                fieldName={key}
                title={
                  key === 'descriptionOfCall'
                    ? FCT.ACTIVITY_LOGS.DESCRIPTION_OF_CALL
                    : FCT.ACTIVITY_LOGS.REASON_FOR_PT_INFO
                }
                value={value as ActivityLogDetailValue}
              />
            );
          }

          if (!IGNORED_FIELDS.includes(key) && (value || value === 0)) {
            return (
              <ActivityLogDetail
                key={key}
                action={action}
                fieldName={key}
                title={generateTitle(key)}
                value={value as ActivityLogDetailValue}
              />
            );
          }

          return null;
        })}
    </div>
  );
}
